// extracted by mini-css-extract-plugin
export default {"Button":"Buttons__Button__PkFr2"};